import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
} from "@material-ui/core";
import { ButtonDark } from "../../ui/templates/buttons";
import { Dropdowns } from "../../ui/templates/dropdown";
import { EN } from "../../ui/constants";

class PendingMembers extends React.Component {
  render() {
    const { team, handleDeleteMember, handleRoleChange } = this.props;

    return (
      <Table className="tableStyleTeam">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "100px" }}>No#</TableCell>
            <TableCell style={{ width: "200px" }}>Name</TableCell>
            <TableCell style={{ width: "200px" }}>Email</TableCell>
            <TableCell style={{ width: "200px" }}>Type</TableCell>
            <TableCell style={{ width: "350px" }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {team?.pending_members?.map((i, k) => (
            <TableRow key={k} id={i.id}>
              <TableCell>{++k}</TableCell>
              <TableCell>
                {i.first_name} {i.last_name}
              </TableCell>
              <TableCell style={{textTransform:'none'}}>{i.email}</TableCell>
              <TableCell>{i.type}</TableCell>
              <TableCell>
                <ButtonGroup aria-label="Basic example">
                  <ButtonDark
                    text="Delete"
                    onClick={() => handleDeleteMember(i.id)}
                  />
                  <Dropdowns
                    id={i.id}
                    text="Approve"
                    items={EN.role}
                    onClick={handleRoleChange}
                  />
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
}

export default PendingMembers;
